import { render } from "./dataDokumen.vue?vue&type=template&id=950844c6"
import script from "./dataDokumen.vue?vue&type=script&lang=js"
export * from "./dataDokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__